/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {DialogButton} from './dialog-button';
import {DialogItem} from './dialog-item';
import {Group} from './group';
import {MapOptions} from './map-options';


export class Dialog {
  id: number;
  name: string;
  level: Level;
  type: string;
  description: string;
  message: string;
  messageHeader: string;
  itemsHeader: string;
  responseTime: number;
  showMap: boolean;
  mapOptions: MapOptions;
  showRadio: boolean;
  showComment: boolean;
  uuid: string;

  items: DialogItem[];
  buttons: DialogButton[];
  groups: Group[];
}

export enum Level {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW"
}
